<template>
    <z-windowPop 
    :render="show"  
    :title="title"
    :tip="true"
    :noBtns="true" 
    :height="read?'500px':'80%'" 
    :width="'1000px'" 
    @cancel="close"
    >
        <div slot="tab-title">
            <div v-if="read || quit" :class="{active:activeIndex == 4}" @click="changeTab(4)">个人信息</div>
            <div v-if="!read && !quit" :class="{active:activeIndex == 0}" @click="changeTab(0)">个人信息</div>
            <div v-if="!read || quit" :class="{active:activeIndex == 1}" @click="changeTab(1)">结算明细</div>
            <div v-if="!read || quit" :class="{active:activeIndex == 2}" @click="changeTab(2)">职级明细</div>
            <div :class="{active:activeIndex == 3}" @click="changeTab(3)">个人罚单</div>
        </div>

        <div class="tab-wrap">
            <infoRead v-if="read || quit" v-show="activeIndex == 4" :index="activeIndex"  :id="user_id" @getdata="getUser"></infoRead>
            <infoTpl v-if="!read && !quit" v-show="activeIndex == 0" :index="activeIndex"  :id="user_id" @getdata="getUser"></infoTpl>
            <settle v-if="!read || quit" v-show="activeIndex == 1" :index="activeIndex" :id="user_id"></settle>
            <rank v-if="!read || quit" v-show="activeIndex == 2" :index="activeIndex" :id="user_id"></rank>
            <ticket v-show="activeIndex == 3" :index="activeIndex" :id="user_id"></ticket>
        </div>
    </z-windowPop>
</template>

<script>
    import infoRead from './tab/personInfo-read.vue'
    import infoTpl from './tab/person-info.vue'
    import settle from './tab/person-settle.vue'
    import rank from './tab/person-rank.vue'
    import ticket from './tab/person-ticket.vue'

    export default {
        components:{
            infoRead,infoTpl,settle,rank,ticket,
        },
        props:{
            show:{
                type:Boolean,
                default:false,
            },
            id:{
                type:Number,
            },
            read:{
                type:Boolean,
                default:false,
            },
        },
        data(){
            return {
                data:{},
                activeIndex:-1,
            }
        },

        computed:{
            user_id(){
                return this.id;
            },
            title(){
                let data = this.data;
                let str = data.buIdentityType == 1?"合伙人":'职员';
                return data.buIdentityType ? `${str}-${data.realName}(${data.bu.buName})` : '';
            },
            quit(){  //已离职
                return this.data.bu && this.data.bu.type == 20;
            },
        },

        watch:{
            show(val){
                if(val == true){
                    if(this.read == true || this.quit == true){
                        this.activeIndex = 4;
                    }else{
                        this.activeIndex = 0;
                    }
                }else{
                    requestAnimationFrame(()=>{
                        this.activeIndex = -1;
                    })
                }
            },

        },

        methods:{
            changeTab(index){
                this.activeIndex = index;
            },
            getUser(data){
                this.data = data;
                this.$emit('infoChange')
            },
            close(){
                this.$form.clear('back-add-person');
                this.$emit('close');
            },
        },

    }
</script>

<style lang="less" scoped>
    .tab-wrap{
        height: 100%;
        box-sizing: border-box;
        padding: 0 20px;
        >div{
            height: 100%;
            padding-top: 0.1px;
        }
    }
</style>



// WEBPACK FOOTER //
// person-pop-info.vue?4a40ca9c